// extracted by mini-css-extract-plugin
export default {"message":"WHjLYQ0wvXzzWaQHas7h","agent":"Ds77go6JRzVBS8bW2Ioe","user":"u1mYbxpzhOfbaw8y8_Cn"};